import { useEffect, useState } from "react";
import api from "../services/api";
import loader from "../images/loader.gif";
import { useDictionary } from "../context/useDictionary";
import { OrgChartView } from "@tw/tw-common-js";
import EmployeViewModal from "../components/employee/EmployeViewModal";

export default function OrgChart() {
  const { getDictionaryValueObject, getDictionaryValue } = useDictionary();

  const [divisions, setDivisions] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [teams, setTeams] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [loading, setLoading] = useState(true);
  const [executiveList, setExecutiveList] = useState([]);

  useEffect(() => {
    async function fetchData() {
      const [divRes, deptRes, teamRes, empRes, execRes] = await Promise.all([
        api.getDivisionsStructure(),
        api.getDepartmentsStructure(),
        api.getTeamsStructure(),
        api.getEmployees(),
        api.getExecutiveLeadership(),
      ]);
      const divs = [...(divRes.data || divRes)]
        .filter((d) => !d.isArchived)
        .sort((a, b) => {
          const aId = a.TWDivisionId;
          const bId = b.TWDivisionId;
          if (aId === null || aId === undefined || aId === "") return 1;
          if (bId === null || bId === undefined || bId === "") return -1;
          if (!isNaN(aId) && !isNaN(bId)) return Number(aId) - Number(bId);
          return aId?.toString().localeCompare(bId?.toString());
        });
      setDivisions(divs);
      setDepartments(deptRes.data || deptRes);
      setTeams(teamRes.data || teamRes);
      setEmployees((empRes.data || empRes).filter((e) => !e.isArchived));
      setExecutiveList(execRes.data || execRes);

      setLoading(false);
    }
    fetchData();
  }, []);

  if (loading) {
    return (
      <div className="orgchart-loader-container">
        <div className="loader">
          <img alt="loader" src={loader} />
          <div>Loading...</div>
        </div>
      </div>
    );
  }

  return (
    <OrgChartView
      divisions={divisions}
      departments={departments}
      teams={teams}
      employees={employees}
      getDictionaryValue={getDictionaryValue}
      getDictionaryValueObject={getDictionaryValueObject}
      executiveList={executiveList}
      getProfileImgThumb={api.getProfileImgThumb}
      EmployeeViewModal={EmployeViewModal}
    />
  );
}
